import { groupBy, uniq } from 'lodash-es';
import { createErrorObject } from "../../components/ImportWizard/ImportWizard.utils";
import { errorMessages } from "./servicesValidation.utils";
export function extractBundles(data) {
  return data.reduce((acc, row) => {
    if (row.bundleName) {
      acc.bundleRows.push(row);
    } else {
      acc.nonBundleRows.push(row);
    }
    return acc;
  }, {
    bundleRows: [],
    nonBundleRows: []
  });
}
export function validateBundleUniqueIncludedServices(bundleServices) {
  const errors = [];
  Object.entries(bundleServices).forEach(_ref => {
    let [bundleName, {
      services
    }] = _ref;
    services.forEach(service => {
      const sameServiceRows = services.filter(_ref2 => {
        let {
          serviceName
        } = _ref2;
        return serviceName === service.serviceName;
      });
      if (sameServiceRows.length > 1) {
        errors.push(createErrorObject('service name', service.lineNumber, errorMessages.getBundleUniqueServicesError(bundleName, service.serviceName)));
      }
    });
  });
  return errors;
}
export function validateBundleServicesSize(bundleServices) {
  const errors = [];
  Object.entries(bundleServices).forEach(_ref3 => {
    let [bundleName, {
      services,
      lineNumber
    }] = _ref3;
    if (services.length < 2) {
      errors.push(createErrorObject('bundle name', lineNumber, errorMessages.getBundleMustHave2ServicesError(bundleName)));
    }
  });
  return errors;
}
export function validateBundleColumnsConsistency(bundlesColumnDataToValidate, columnsToValidate) {
  const errors = [];
  const bundles = groupBy(bundlesColumnDataToValidate, row => row.bundleName);
  Object.values(bundles).forEach(bundleRows => {
    if (bundleRows.length > 1) {
      const inconsistentColumns = [];
      columnsToValidate.forEach(column => {
        const values = bundleRows.map(row => row[column]);
        const uniqueValues = uniq(values);
        if (uniqueValues.length > 1) {
          inconsistentColumns.push(column);
        }
      });
      if (inconsistentColumns.length > 0) {
        errors.push(createErrorObject('bundle name', bundleRows[0].lineNumber, errorMessages.getBundleColumnsConsistencyError(bundleRows[0].bundleName, inconsistentColumns)));
      }
    }
  });
  return errors;
}